export const ONE_HOUR_IN_MILLIS = Object.freeze(1000 * 60 * 60);
export const ONE_DAY_IN_MILLIS = Object.freeze(24 * ONE_HOUR_IN_MILLIS);
export const ONE_WEEK_IN_MILLIS = Object.freeze(7 * ONE_DAY_IN_MILLIS);
export const ONE_MINUTE_IN_MILLIS = Object.freeze(60 * 1000);
export const FIVE_MINUTES_IN_MILLIS = Object.freeze(5 * ONE_MINUTE_IN_MILLIS);
export const TEN_MINUTES_IN_MILLIS = Object.freeze(10 * ONE_MINUTE_IN_MILLIS);
export const FIFTEEN_MINUTES_IN_MILLIS = Object.freeze(15 * ONE_MINUTE_IN_MILLIS);
